import AppRouter from '@app/routes';
import { MobileAppBanner } from '@components/layout/mobile-app-banner';
import { ConfirmDialogHost } from '@components/ui';
import { ApiUrl } from '@config/apiUrl';
import {
  type FcmMessagePayload,
  onMessageListener,
} from '@config/firebase';
import { HireJobProvider } from '@features/buyer/hire/hire-job-context';
import {
  Notification,
  ReactNotifications,
} from '@features/notifications';
import { fetchFeatureFlags } from '@lib/featureFlags';
import { logError } from '@lib/logError';
import { queryClient } from '@lib/queryClient';
import { useEffect, useState } from 'react';
import { io, type Socket } from 'socket.io-client';

const socket: Socket = io(ApiUrl.socket_url);

const App = (): JSX.Element => {
  const [showNotification, setShowNotification] = useState(false);
  const [notification, setNotification] = useState({
    title: '',
    body: '',
  });

  useEffect(() => {
    fetchFeatureFlags();

    onMessageListener()
      .then((payload: FcmMessagePayload) => {
        queryClient.invalidateQueries({ queryKey: ['jobs'] });
        queryClient.invalidateQueries({ queryKey: ['dashboard'] });
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
        setShowNotification(true);
        setNotification({
          title: payload.notification?.title ?? '',
          body: payload.notification?.body ?? '',
        });
      })
      .catch((error: unknown) => {
        logError('push notifications', error);
      });
  }, []);

  return (
    <>
      <MobileAppBanner />
      <ConfirmDialogHost />
      {showNotification ? (
        <ReactNotifications
          title={notification.title}
          body={notification.body}
        />
      ) : null}
      <HireJobProvider>
        <Notification />
        <AppRouter socket={socket} />
      </HireJobProvider>
    </>
  );
};
export default App;
